// extracted by mini-css-extract-plugin
export default {"child":"_--Y2m","remover":"JYQ-5","icon":"vLMTf","addChildBlock":"xliuE","agesTitle":"Ogei5","age":"PHAaw","age--isLast":"iyAxv","agesList":"G0BrZ","skeleton-progress":"QQfah"};